export default __webpack_public_path__ + "static/media/catlist_img3.12b90398.png";